import React, { useEffect } from 'react';
import { fieldNames } from '../../../common/config';
import { useShutdownCities } from '../../../../../shared/api/queries/shutdownCities';
import { Form, Icon, Tooltip } from 'antd';
import DropdownSelect from '../../../../../../../components/dropdownSelect';
import { getRenderControl } from '../../../../../../../components/SingleControlCustom/getRenderControl';
import { getOptionsBySelect } from '../../lib/getOptionsBySelect';
import useCompanies from '../../../../../../../queries/useCompanies';

const cityFieldName = fieldNames.city;
const companyFieldName = fieldNames.company;
const initiatorsFieldName = fieldNames.initiators;
const notifyToFieldName = fieldNames.notifyTo;
const FormItem = Form.Item;

const CityField = ({ form }) => {
  const companyId = form.getFieldValue(companyFieldName);

  const { data = [], isFetching: isCitiesFetching } = useShutdownCities(
    companyId,
    {
      staleTime: Infinity,
      enabled: !!companyId,
    }
  );

  const { isFetching: isFetchingCompany } = useCompanies({
    staleTime: Infinity,
  });

  const loading = Boolean(isCitiesFetching);
  const disabled = Boolean(
    loading ||
      !companyId ||
      !data ||
      isFetchingCompany ||
      (data.length === 1 && form.getFieldValue(cityFieldName))
  );

  const options = getOptionsBySelect(data);

  const handleCityChange = (value) => {
    form.setFieldsValue({
      [cityFieldName]: value,
      [initiatorsFieldName]: [],
      [notifyToFieldName]: [],
    });
  };

  useEffect(() => {
    if (data && data.length === 1 && !form.getFieldValue(cityFieldName)) {
      form.setFieldsValue({ [cityFieldName]: data[0].id });
    }
  }, [data, companyId]);

  return (
    <FormItem
      style={{ margin: 0 }}
      label={
        <span>
          Город&nbsp;
          <Tooltip title="На основе города формируются списки инициаторов, адресов и тех, кому отправить уведомления">
            <Icon
              type="info-circle"
              style={{ fontSize: '16px' }}
            />
          </Tooltip>
        </span>
      }
    >
      {form.getFieldDecorator(cityFieldName, {
        rules: [
          {
            required: true,
            message: 'Укажите город',
          },
        ],
      })(
        <DropdownSelect
          onChange={handleCityChange}
          multiple={false}
          options={options}
          renderControl={getRenderControl({
            options: options,
            isClear: false,
            value: form.getFieldValue(cityFieldName),
            disabled,
            loading,
          })}
        />
      )}
    </FormItem>
  );
};

export default CityField;
